import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=4bc735b6&scoped=true&"
import script from "./loadingIcon.vue?vue&type=script&lang=js&"
export * from "./loadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./loadingIcon.vue?vue&type=style&index=0&id=4bc735b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc735b6",
  null
  
)

export default component.exports